import { h, Component } from 'preact';
import style from './style';

import Button from '@components/button';
import { Stateful } from '@components/pubsub';

import CitySelector from '@components/cityselector';
import Text from '@components/translate';
import I18n from '@i18n';
import { slugify, getCity } from '@helpers';

class SearchField extends Component {
  render(
    { autofocus, onChange, showCityFilter = false },
    { query = '', focus = false, showCitySelector = false },
    { lang }
  ) {
    return (
      <Stateful events={['city']}>
        {({ city = getCity() }) => (
          <div
            class={`${style.searchField} ${focus ? style.focus : ''} ${
              !showCityFilter ? style.noCityFilter : ''
            }`}
          >
            {showCityFilter && (
              <div class={style.cityFilterContainer}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                </svg>
                <a
                  href={`/${lang}/${slugify(city)}`}
                  class={style.citySelection}
                  ref={el => (this.citySelector = el)}
                  onMouseEnter={() => this.setState({ showCitySelector: true })}
                >
                  {city}
                </a>
              </div>
            )}

            <form
              class={style.searchForm}
              method="GET"
              action={`/${lang}/search`}
            >
              <input type="hidden" name="city" value={city} />
              <input
                class={style.searchInput}
                placeholder={focus ? null : I18n.t('Search')}
                aria-label={I18n.t('Search')}
                name="q"
                autocomplete="off"
                value={query}
                autofocus={autofocus}
                onInput={e => {
                  this.setState({ query: e.target.value }, () => {
                    if (onChange) {
                      onChange(this.state.query);
                    }
                  });
                }}
                onFocus={() => {
                  this.setState({ focus: true });
                }}
                onBlur={() => {
                  this.setState({ focus: false });
                }}
              />

              <Button class={style.searchButton} name={I18n.t('Search')}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class={style.searchIcon}
                >
                  <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z" />
                </svg>
              </Button>
            </form>

            {showCityFilter && (
              <CitySelector
                show={showCitySelector}
                onClose={() => this.setState({ showCitySelector: false })}
                anchor={this.citySelector}
              />
            )}

            {query && window.tableOnlineShowAutocomplete ? (
              <div class={style.autocomplete}>
                <label class={style.autocompleteSuggestion}>
                  <h5 class="hug">
                    <Text>{I18n.t("Search")}</Text> {query}
                  </h5>
                  <h6 class="hug">
                    <Text>{I18n.t("From city")}</Text>{' '}
                    <strong>
                      <Stateful events={['city']}>
                        {({ city = getCity() }) => city}
                      </Stateful>
                    </strong>
                  </h6>
                </label>
                <label class={style.autocompleteSuggestionSmall}>
                  <h5 class="hug">
                    <Text>{I18n.t("Restaurant name")}</Text>: {query}
                  </h5>
                </label>
                <label class={style.autocompleteSuggestionSmall}>
                  <h5 class="hug">
                    <Text>{I18n.t("Restaurant from city")}</Text>: {query}
                  </h5>
                </label>
                <label class={style.autocompleteSuggestionSmall}>
                  <h5 class="hug">
                    <Text>{I18n.t("Restaurant with kitchen")}</Text>: {query}
                  </h5>
                </label>
              </div>
            ) : null}
          </div>
        )}
      </Stateful>
    );
  }
}
export default SearchField;



// WEBPACK FOOTER //
// ./components/searchfield/index.js